import { render, staticRenderFns } from "./CAdContainer.vue?vue&type=template&id=0084be4f&scoped=true&"
import script from "./CAdContainer.vue?vue&type=script&lang=ts&"
export * from "./CAdContainer.vue?vue&type=script&lang=ts&"
import style0 from "./CAdContainer.vue?vue&type=style&index=0&id=0084be4f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0084be4f",
  null
  
)

export default component.exports